module.exports = __webpack_public_path__ + "assets/f6924f512144d80873c88df8b1185c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/cz/0.png
// module id = 365
// module chunks = 1